document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.next-header');
  const desktopDropdowns = header.querySelectorAll(
    '.next-header__desktop-menu-dropdown'
  );
  const mobileDropdowns = header.querySelectorAll(
    '.next-header__mobile-menu-dropdown'
  );
  const hamburgerButtons = header.querySelectorAll('.next-header__hamburger');
  const mobileMenu = header.querySelector('.next-header__mobile-menu');

  // Desktop dropdowns
  desktopDropdowns.forEach((dropdown) => {
    const button = dropdown.querySelector('button');
    const content = dropdown.querySelector(
      '.next-header__desktop-menu-dropdown-content'
    );
    let closeTimeout;

    dropdown.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      content.setAttribute('data-open', 'true');
      button.setAttribute('data-open', 'true');
    });

    dropdown.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => {
        content.classList.add('closing');
        button.setAttribute('data-open', 'false');
        setTimeout(() => {
          content.setAttribute('data-open', 'false');
          content.classList.remove('closing');
        }, 150);
      }, 100);
    });
  });

  // Mobile dropdowns
  mobileDropdowns.forEach((dropdown) => {
    const button = dropdown.querySelector('button');
    const content = dropdown.querySelector(
      '.next-header__mobile-menu-dropdown-content'
    );

    button.addEventListener('click', () => {
      const isOpen = button.getAttribute('data-open') === 'true';
      button.setAttribute('data-open', !isOpen);
      content.setAttribute('data-open', !isOpen);
    });
  });

  // Hamburger menu
  hamburgerButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.stopPropagation(); // Prevent this click from immediately closing the menu
      const isOpen = mobileMenu.getAttribute('data-open') === 'true';
      toggleMobileMenu(!isOpen);
    });
  });

  // Function to toggle mobile menu
  function toggleMobileMenu(open) {
    mobileMenu.setAttribute('data-open', open);
    hamburgerButtons.forEach((btn) => btn.setAttribute('data-open', open));
  }

  // Close mobile menu when clicking outside
  document.addEventListener('click', (e) => {
    if (
      !mobileMenu.contains(e.target) &&
      !Array.from(hamburgerButtons).some((btn) => btn.contains(e.target)) &&
      mobileMenu.getAttribute('data-open') === 'true'
    ) {
      toggleMobileMenu(false);
    }
  });
});
